import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import UpgradeModalParent from '@/components/agency-billing/subscriptions/UpgradeModalParent.vue';
import { setupVueI18n } from '@/plugin/vue-i18n';
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { provide } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpgradeModal',
    props: {
        company: Object,
        user: Object,
        emitter: Object,
        source: String,
    },
    setup(__props) {
        setupVueI18n();
        const props = __props;
        provide('company', ref(props.company));
        provide('user', props.user);
        provide('emitter', props.emitter);
        provide('source', props.source);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), { "full-screen": "" }, {
                default: _withCtx(() => [
                    _createVNode(UpgradeModalParent)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
